import React, { useEffect, useState } from "react";

function Cart({ isEnglish, theme }) {
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const savedOrder = JSON.parse(localStorage.getItem("cart")) || null;
    setOrder(savedOrder);
  }, []);

  const getTimeSincePurchase = (createdAt) => {
    const now = new Date();
    const purchaseDate = new Date(createdAt);
    const diff = Math.floor((now - purchaseDate) / 1000); // بالثواني

    const days = Math.floor(diff / (60 * 60 * 24));
    const minutes = Math.floor((diff % (60 * 60)) / 60);

    return `${days} ${isEnglish ? "days" : "يوم"} و ${minutes} ${isEnglish ? "minutes" : "دقيقة"}`;
  };

  return (
    <div
      className={`cart-page ${theme}`}
      style={{
        padding: "40px",
        backgroundColor: theme === "dark" ? "#1e1e1e" : "#f5e4d5",
        minHeight: "100vh",
        color: theme === "dark" ? "#fff" : "#804000",
        fontSize: "18px",
        lineHeight: "2",
      }}
    >
      {order ? (
        <div>
          <p>
            <strong>{isEnglish ? "Service Title" : "عنوان الخدمة"}:</strong> {order.name}
          </p>
          <p>
            <strong>{isEnglish ? "Order Status" : "حالة الطلب"}:</strong> {isEnglish ? "In Progress" : "قيد التنفيذ"}
          </p>
          <p>
            <strong>{isEnglish ? "Order Value" : "قيمة الطلب"}:</strong> {order.price} $
          </p>
          <p>
            <strong>{isEnglish ? "Purchase Date" : "تاريخ الشراء"}:</strong>{" "}
            {isEnglish ? `Since ${getTimeSincePurchase(order.createdAt)}` : `منذ ${getTimeSincePurchase(order.createdAt)}`}
          </p>
          <p>
            <strong>{isEnglish ? "Delivery Date" : "تاريخ التسليم"}:</strong> {order.deliveryDate}
          </p>
        </div>
      ) : (
        <p style={{ fontSize: "20px" , marginTop: "80px" }}>
          {isEnglish ? "You haven't purchased anything yet." : "لم تقم بشراء شيء بعد."}
        </p>
      )}
    </div>
  );
}

export default Cart;
